import {createRouter, createWebHistory} from '@ionic/vue-router';
import {routes} from "./routes";
import vpn from "@/router/guards/vpn";
import {useMainStore} from "@/store";

const router = createRouter({
  history: createWebHistory('/'),
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes
});

router.beforeEach(vpn);

router.beforeEach((to) => {
    const store = useMainStore();
    if (store.replayMode && to.name !== 'bout-replay' && to.name !== 'masquerade') {
        return false;
    }
});

export default router;
